<template>
  <div>
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader"></h3>
    <!-- <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="created_at" fixed width="160" label="申请时间">
        </custom-table-column>
        <custom-table-column prop="applicant_name" width="120" label="申请人">
        </custom-table-column>
        <custom-table-column prop="device_name" width="120" label="设备名">
        </custom-table-column>
        <custom-table-column prop="status_text" width="100" label="审批状态">
        </custom-table-column>
        <custom-table-column prop="auth_type_text" width="100" label="密码类型">
        </custom-table-column>
        <custom-table-column prop="use_end_time" width="180" label="使用开始时间">
        </custom-table-column>
        <custom-table-column prop="use_start_time" width="180" label="使用结束时间">
        </custom-table-column>
        <custom-table-column prop="reason" min-width="220" label="使用说明">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="scope.row.status == 2">
            <el-button @click="getTemPwd(scope.row.indexCode)" type="text" size="small">查看临时密码</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" title="授权申请" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="使用开始时间" prop="use_start_time">
          <el-date-picker type="datetime" placeholder="请选择" clearable value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.use_start_time" style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="使用结束时间" prop="use_end_time">
          <el-date-picker type="datetime" placeholder="请选择" clearable value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.use_end_time" style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="使用说明" prop="reason">
          <el-input type="textarea" v-model="ruleForm.reason" :rows="5" placeholder="请输入"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', updateMethod)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
      },
      ruleForm: {
        device_index_code: '',
        use_start_time: '',
        use_end_time: '',
        reason: ''
      },
      rules: {
        reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        use_start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        use_end_time: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      tableData1: [],
      total1: 0,
      loading: false,
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleApplyPwd(device_index_code) {
      this.ruleForm.device_index_code = device_index_code
      this.centerDialogVisible = true
    },

    async getTemPwd(device_index_code) {
      let params = { device_index_code };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock-auth/temp-password', 'post', params);
      if (res.code == 0 && res.data) {
        this.codeWin(res.data, '临时密码授权')
      }
    },
    codeWin(res, title) {
      const code = res.password
      const html = this.$createElement
      let spans = []
      spans.push(<p class='tip-warn'>有效期：{res.auth_type == "long" ? "长期" : "5分钟"}</p>)
      for (let i = 0; i < code.length; i++) {
        spans.push(<span class='lock-code'>{code[i]}</span>)
      }
      this.$msgbox({
        title,
        message: html('div', { class: 'lock-box' }, spans),
        showCancelButton: false,
        showConfirmButton: false,
      }).then(action => {
      });
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/smart_lock/smart-lock-auth/submit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '申请成功！',
        });
        this.centerDialogVisible = false
      }
    },
    async getOfflineCode(device_index_code) {
      let params = { device_index_code };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/offline-password', 'post', params);
      if (res.code == 0 && res.data) {
        if (res.data.offlineCode) {
          this.codeWin(res.data.offlineCode, '离线开门口令')
        } else {
          this.$message({
            type: 'warning',
            message: `未找到口令!`,
          });
        }
      }
    },
    handleOpen(indexCode, operation_type, str) {
      this.$confirm(`此操作将${str}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.openLock(indexCode, operation_type);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async openLock(device_index_code, operation_type) {
      let params = { device_index_code, operation_type };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/open-door', 'get', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `操作成功!`,
        });
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock-auth/records', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.lock-box {
  text-align: center;
  padding: 24px 0;

  span {
    padding: 6px;
    margin: 4px 8px;
    font-size: 22px;
    border-radius: 4px;
    // text-decoration: underline;
    border: 1px solid #cfcfcf;
  }
}

.tip-warn {
  font-size: 13px;
  color: #ec2828;
  text-align: center;
  margin-bottom: 24px;
}

@media screen and (max-width: 1000px) {
  .pageHeader {
    border-bottom: 0;
  }

  /deep/.header-info-icon {
    bottom: 18px;
  }
}

@media screen and (min-width: 1000px) {
  .pageHeader {
    display: none;
  }
}

.pageHeader:before {
  width: var(--width);
}
</style>
